import { Tabs as MuiTabs, Tab as MuiTab } from '@mui/material'
import styled from 'styled-components'
import { sizes } from '@qflow/theme'

export const Tabs = styled(MuiTabs)`
  & .MuiTabs-indicator {
    background-color: ${({ theme }) => theme.primary.highlight};
  }

  & .MuiButtonBase-root {
    min-height: 2rem;
    padding: 0.5rem 0.75rem;
  }

  & .MuiTab-textColorInherit {
    color: ${({ theme }) => theme.primary.fgDim};

    opacity: 1;
  }

  & .MuiTab-textColorInherit:disabled {
    color: ${({ theme }) => theme.primary.fgDim};

    opacity: 0.5;
  }

  & .MuiTab-textColorInherit.Mui-selected {
    color: ${({ theme }) => theme.primary.fg};

    opacity: 1;
  }

  & .MuiTab-root {
    min-width: auto;
    font-size: ${sizes.SMALL};
  }
`

export const Tab = styled(MuiTab)``
